module.exports = __webpack_public_path__ + "static/dolly1-4a4cc70ca34b02b89985cca6428b3106.jpg";